class AccordionBlock {
    constructor(element) {
        this.element = element;
        this.bindListeners();
    }

    bindListeners() {
        let el = this.getElement();
        let oneAtATime = el.dataset['openMode'] == 'one';
        let sections = el.querySelectorAll('section');
        sections.forEach(function(section) {
            section.querySelectorAll('h2,h3,h4').forEach(function(heading){
                heading.addEventListener('click', function() {
                    if(oneAtATime) {
                        sections.forEach(function(otherSection) {
                            otherSection.classList.remove('-open');
                        });
                    }
                    section.classList.toggle('-open');
                    // TODO ensure if title is above viewport, scroll to heading
                })
            });
        });
    }

    getElement() {
        return this.element;
    }

    static init() {
        document.querySelectorAll('.bl-accordion').forEach(function(element) {
            new AccordionBlock(element);
        });
    }
};

export default AccordionBlock;
